import styled from "styled-components";

export const IconWrapper = styled.div`
  width: 40px;
  max-width: 40px;
  height: 40px;
  max-height: 40px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  :hover,
  :focus,
  :active {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  @media (min-width: 1600px) {
    width: 50px;
    height: 50px;
  }
`;

export const Icon = styled.img`
width: 20px;
@media (min-width: 1600px) {
  width: 28px;
}
`;

export const Info = styled.div`
  margin-left: ${(p) => p.theme.spacing.sm};
`;

export const Heading = styled.div`
position: relative;
display: flex;
    align-items: center;
  font-size: 24px;
    letter-spacing: 1px;
    font-weight: 600;
  margin-bottom: ${(p) => p.theme.spacing.sm};
  font-family: ${(p) => p.theme.font.family.SweraDemo};

  ${(p) =>
    p.STACKINGCALCULATOR &&
    `
      font-size: 24px;
      font-family: 'Lato';
      color:white;
      padding : 0px 20px;
      margin-bottom: 0px !important;

  `}
  ${(p) =>
    p.harvestheading &&
    `
      padding-top:30px;

  `}
`;

export const Text = styled.div`
color: ${(p) => p.theme.colors.lightskytextcolor};
@media (min-width: 1600px) {
  font-size: ${(p) => p.theme.font.size.md};
}
`;

export const BoldText = styled.div`
font-size: ${(p) => p.theme.font.size.lg};
font-weight: ${(p) => p.theme.font.weight.bold};
margin-top: ${(p) => p.theme.spacing.xs};
@media (min-width: 1600px) {
  font-size: ${(p) => p.theme.font.size.xl};
}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;

  ${(p) =>
    p.Depositewrapper &&
    `
    width: "50%";
    display: flex;
    justify-content: flex-start;
   
 `}
`;



export const IconStackedContainer = styled.div`
display: flex;
flex-direction: space-between;
`;

export const InputWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
text-align: center;
`;

export const Input = styled.input`
padding: 10px 15px;
font-size: 16px;
font-weight: 400;
width: 95% !important;
height: 50px;
margin: 0px;
outline: none;
border: none;
border-radius: 25px;
${(p) =>
  p.PopUpText &&
  `
font-size: 22px;

`}
`;

export const SelectWrapper = styled(InputWrapper)`
width: 100%;
/* margin: 20px 0 10px 0; */
`;

export const SelectHeading = styled.text`
font-size: 10px 15px;
margin-bottom: 10px;
font-weight: 500;
${(p) =>
  p.PopUpText &&
  `
color:white;
font-size: 17px;
`}
`;

export const Select = styled.select`
padding: 10px 15px;
width: 100% !important;
margin: 0px;
outline: none;
border: none;
font-size: 22px;
border-radius: 25px;
cursor: pointer;
`;

export const LordRatioWrapper = styled.div`
/* margin: 10px 20px 0px 20px; */
width: 100%;
`;

export const Option = styled.option`
${(p) =>
  p.PopUpText &&
  `
font-size:22px;
`}
`;

export const LordpriceWrapper = styled.div`
display: flex;
align-items: flex-end;
margin-top: 5px;
flex-direction:row;
@media(max-Width: 768px){
  flex-direction: column;
  align-items: flex-start;
}
@media(max-Width: 1024px){
  /* flex-direction: column; */
  /* align-items: flex-start; */
  
}
`;

export const LordTextWrapper = styled.div`
display: flex;
justify-content: center;
align-items: Center;
`;

export const LordText = styled.text`
font-size: 15px;
text-decoration: underline;
margin: 0 12px;
font-weight: 800;
color: #88fefe;
text-transform: uppercase;
@media(max-Width: 768px){
  margin: 0;
}
@media(max-Width: 1024px){
  margin: 0;
}
`;

export const Lordprice = styled.p`
margin: 5px 0 0 0 !important;
font-size: 15px;
@media(max-Width: 768px){
  font-size: 12px;
}
@media(max-Width: 1024px){
  font-size: 12px;
}
`;

export const RequiredText = styled.text`
color: red;
font-size: 15px;
font-weight: 700;
margin-bottom: 5px;
`;

export const TotalMldTentureAmountContainer = styled.div`
display: flex;
justify-content: flex-start;
align-items: flex-start;
width: 100%;
`;

export const MaxbuttonWrapper = styled.div`
width: 50%;
display: flex;
`;

export const DepositeContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: baseline;
text-align: center;
margin-top: 25px;
`;

export const MaxButton = styled.button`
padding: 12px 20px;
height: 50px;
border-radius: 25px;
border: none;
font-size: 18px;
outline: none;
cursor: pointer;
font-weight: 500;
width: 95%;

`;

export const CalculatorButtonWrapper = styled.div`
margin: 20px 0 40px;
`;

export const CalculatorButton = styled.button`
width: 100%;
font-size: 18px;
color: #88fefe;
border: 1px solid #88fefe;
background-color: transparent;
cursor: pointer;
border-radius: 25px;
font-weight: 400;
outline: none;
padding: 15px;
`;

export const CalculatorCardWrapper = styled.div`
margin: 10px 0;
`;

export const LineWrapper = styled.div`
width: 100%;
`;

export const Line = styled.div`
width: 100%;
height: 2px;
border: 2px solid white;
border-radius: 25px;
`;

export const PreMaturityTextWrapper = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
@media(max-width:768px){
  justify-content: space-between;
}
@media(max-width:1024px){
  justify-content: space-between;
}
`;

export const PreMaturityText = styled.text`
display: flex;
text-align: start;
font-size: 24px;
width: 50%;
padding-bottom: 20px;
color: white;
@media(max-width:768px){
font-size:18px;
width: auto;
}
`;

export const PreMaturityTextBig = styled.text`
display: flex;
justify-content: right;
align-items: center;
font-size: 30px;
width: 50%;
padding-bottom: 20px;
font-weight: 600;
color: white;
@media(max-width:768px){
font-size:26px;
width: auto;
}
`;

export const PreMaturityContainer = styled.div`
width: 100%;
margin-top: 20px;
`;

export const ConfirmButtonContainer = styled.div`
display: flex;
justify-content: center;
width: 100%;
margin-top: 20px;
`;

export const ConfirmButtonWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
`;

export const ConfirmButton = styled.button`
background: none;
border: 1px solid #88fefe;
border-radius: 25px;
outline: none;
color: #88fefe;
font-weight: 500;
cursor: pointer;
margin: 10px 5px;
font-size: 16px;
padding: 15px 45px;
font-size: 20px;

${(p) =>
  p.ConfirmButton &&
  `
  background-color: #88fefe;

  color: black;
`}
`;



export const TableWrapper = styled.div`
width: 100%;
overflow-x: auto;
&::-webkit-scrollbar {
  -webkit-appearance: none;
    
        height: 3px;
        border:2px solid #88fefe;
    }
 
`;

export const Table = styled.table`
    overflow: scroll;
    width: 100%;
    margin: 25px 0;
    min-width: 600px; 
    border-collapse: collapse;
`;

export const TableRow = styled.div`
 /* width: 1000px; */
 /* margin: o auto; */
display: grid;
grid-template-columns: 18% 18% 18% 18% 20%;
@media(max-width:1200px){
  grid-template-columns: 20% 20% 20% 20% 20%;
  width: 750px;
  margin: o auto;
}
`;

export const TableRowCellWrapper = styled.div`
display: grid;
/* margin: 0 auto; */
/* width: 1000px; */
grid-template-columns: 18% 18% 18% 18% 20%;
/* justify-content:center; */

align-items:center;
@media(max-width:1350px){
  grid-template-columns: 20% 20% 20% 20% 20%;
  width: 750px;
  margin: o auto;
}
`;

export const TableHead = styled.th`
    color: #9d9d9d;
    font-size: 16px;
text-transform: capitalize;
font-weight: 500;
display: flex;
justify-content: flex-start;
align-items: center;
`;

export const TableCell = styled.td`
  font-size: 20px;
  margin: 15px 0;
  font-weight: 500;
  /* display: flex;
  justify-content: center;
  align-items: center;
  text-align: center; */
  @media(max-Width: 768px){
    margin: 0;
    font-size: 18px;
  }
  @media(max-Width: 1024px){
    margin: 0;
    font-size: 18px;
  }
`;

export const MatureDatatext = styled.text`
font-size: 2rem;
font-family: 'SweraDemo';

`;

export const PrematureButtonWrapper = styled.div``;

export const PrematureButton = styled.button`
font-size: 16px;
color: #88fefe;
background-color: transparent;
border: 1px solid #88fefe;
border-radius: 25px;
outline: none;
padding: 12px 0px;
cursor: pointer;
width: 180px;
`;